import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchCandidateComponent } from './components/search-candidate/search-candidate.component';
import { RouterModule, Routes } from '@angular/router';
import { CandidateFilterComponent } from './components/candidate-filter/candidate-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResumePreviewComponent } from './components/resume-preview/resume-preview.component';
import { SharedModule } from '../shared/shared.module';
import { CandidatesListComponent } from './components/candidates-list/candidates-list.component';
import { ExperiencePreviewComponent } from './components/experience-preview/experience-preview.component';
import { EducationPreviewComponent } from './components/education-preview/education-preview.component';
import { AttachmentsPreviewComponent } from './components/attachments-preview/attachments-preview.component';
import { ViewJobInterestComponent } from './components/view-job-interest/view-job-interest.component';
import { NgbModalModule, NgbModule, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { JobsModule } from '../jobs/jobs.module';
import { MessagesModule } from '../messages/messages.module';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { EducationFormComponent } from './components/education-form/education-form.component';
import { ExperienceFormComponent } from './components/experience-form/experience-form.component';
import { ExperienceAttachmentComponent } from './components/experience-attachment/experience-attachment.component';

const routes: Routes =
  [
    { path: 'search-candidates', component: SearchCandidateComponent },
    { path: 'view-candidate/:resumeId', component: ResumePreviewComponent },
    { path: 'view-job-interest/:jobId/:employerAccountId', component: ViewJobInterestComponent }
  ];

@NgModule({
  declarations: [
    SearchCandidateComponent,
    CandidateFilterComponent,
    CandidatesListComponent,
    ResumePreviewComponent,
    ExperiencePreviewComponent,
    EducationPreviewComponent,
    AttachmentsPreviewComponent,
    ViewJobInterestComponent,
    EducationFormComponent,
    ExperienceFormComponent,
    ExperienceAttachmentComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbModalModule,
    NgbModule,
    JobsModule,
    MessagesModule,
    NgbRatingModule,
    NgxDocViewerModule,
    RouterModule.forChild(routes),
  ],
  exports: [
    CandidateFilterComponent, 
    CandidatesListComponent, 
    ExperiencePreviewComponent, 
    EducationPreviewComponent, 
    AttachmentsPreviewComponent, 
    EducationFormComponent,
    ExperienceFormComponent,
    ExperienceAttachmentComponent
  ]
})
export class CandidatesModule { }
